import { render } from "./Table1.vue?vue&type=template&id=b4f04a82"
import script from "./Table1.vue?vue&type=script&lang=ts"
export * from "./Table1.vue?vue&type=script&lang=ts"

import "./Table1.vue?vue&type=style&index=0&id=b4f04a82&lang=scss"
script.render = render

export default script